import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const NAV_ITEMS = [
  { icon: '⬛', label: 'Dashboard', path: '/dashboard' },
  { icon: '🎬', label: 'Reels', path: '/reels' },
  { icon: '📥', label: 'Fetch by URL', path: '/fetch-reel' },
  { icon: '📤', label: 'Upload Reels', path: '/upload' },
  { icon: '🔗', label: 'OAuth Connect', path: '/connect' },
  { icon: '⚙️', label: 'Manual Connect', path: '/manual-connect' },
  { icon: '▶', label: 'Player Preview', path: '/player' },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <span className="sidebar-logo-accent">Vids</span>
        <span className="sidebar-logo-main">Commerce</span>
      </div>

      <nav className="sidebar-nav">
        {NAV_ITEMS.map(({ icon, label, path }) => (
          <button
            key={path}
            className={`nav-item ${pathname === path ? 'active' : ''}`}
            onClick={() => navigate(path)}
          >
            <span>{icon}</span>
            <span>{label}</span>
          </button>
        ))}
      </nav>

      <div className="sidebar-bottom">
        <div style={{ padding: '12px', marginBottom: '8px' }}>
          <div style={{ fontSize: 12, color: 'var(--text-dim)', marginBottom: 4 }}>Logged in as</div>
          <div style={{ fontSize: 14, fontWeight: 600 }}>{user?.name}</div>
          <div style={{ fontSize: 12, color: 'var(--text-dim)' }}>{user?.role}</div>
        </div>
        <button className="nav-item" onClick={logout}>
          <span>↩</span>
          <span>Log out</span>
        </button>
      </div>
    </aside>
  );
}
